import {
  Ga4TrackingEventData,
  Ga4TrackingEventMap,
  Ga4TrackingEventName,
  Ga4TrackingEventType
} from '@hdms/shared/common-types';

export class Ga4TrackingEventDto<T extends Ga4TrackingEventName> {
  constructor(name: T, augment: Ga4TrackingEventMap[T]) {
    Object.assign(this, Ga4TrackingEventDto.createGa4TrackingEvent(name, augment));
  }
  static create<T extends Ga4TrackingEventName>(
    this: typeof Ga4TrackingEventDto,
    name: T,
    augment?: Ga4TrackingEventMap[T]
  ): Ga4TrackingEventData<T> {
    return new this<T>(name, augment) as Ga4TrackingEventData<T>;
  }

  private static createGa4TrackingEvent<T extends Ga4TrackingEventName>(
    name: T,
    data: Ga4TrackingEventMap[T]
  ): Ga4TrackingEventData<T> {
    let event = Ga4TrackingEventType.GENERIC;
    if ((data as Record<string, Ga4TrackingEventType>).trackingEvent) {
      event = (data as Record<string, Ga4TrackingEventType>).trackingEvent;
      delete (data as Record<string, string>).trackingEvent;
    }
    const { ...parameters } = data;
    return {
      event,
      event_name: name,
      [name]: {
        ...parameters
      }
    } as unknown as Ga4TrackingEventData<T>;
  }
}
